import {
  EligibilityRule,
  EligibilityRules,
} from "@/types/breeze/AnythinkPay";

export type EligibilityFormState = {
  restricted: boolean;
  match: "all" | "any";
  subscribed_to_plan_enabled: boolean;
  plan_ids: number[];
  min_tier_enabled: boolean;
  min_tier_rank: number;
  redeemed_offer_enabled: boolean;
  offer_id: string;
};

export const emptyEligibility = (): EligibilityFormState => ({
  restricted: false,
  match: "all",
  subscribed_to_plan_enabled: false,
  plan_ids: [],
  min_tier_enabled: false,
  min_tier_rank: 1,
  redeemed_offer_enabled: false,
  offer_id: "",
});

export function eligibilityFormToJson(elig: EligibilityFormState): string | null {
  if (!elig.restricted) return null;
  const rules: EligibilityRule[] = [];
  if (elig.subscribed_to_plan_enabled && elig.plan_ids.length > 0) {
    rules.push({ type: "subscribed_to_plan", plan_ids: elig.plan_ids });
  }
  if (elig.min_tier_enabled && elig.min_tier_rank > 0) {
    rules.push({ type: "subscription_min_tier", tier_rank: elig.min_tier_rank });
  }
  if (elig.redeemed_offer_enabled && elig.offer_id) {
    rules.push({ type: "redeemed_offer", offer_id: elig.offer_id });
  }
  if (rules.length === 0) return null;
  const payload: EligibilityRules = { match: elig.match, rules };
  return JSON.stringify(payload);
}

export function eligibilityFromJson(
  json: string | null | undefined,
): EligibilityFormState {
  if (!json || json === "null") return emptyEligibility();
  try {
    const parsed = JSON.parse(json) as EligibilityRules;
    const subPlan = parsed.rules.find((r) => r.type === "subscribed_to_plan");
    const minTier = parsed.rules.find((r) => r.type === "subscription_min_tier");
    const redeemed = parsed.rules.find((r) => r.type === "redeemed_offer");
    return {
      restricted: true,
      match: parsed.match === "any" ? "any" : "all",
      subscribed_to_plan_enabled: !!subPlan,
      plan_ids: subPlan?.plan_ids ?? [],
      min_tier_enabled: !!minTier,
      min_tier_rank: minTier?.tier_rank ?? 1,
      redeemed_offer_enabled: !!redeemed,
      offer_id: redeemed?.offer_id ?? "",
    };
  } catch {
    return emptyEligibility();
  }
}
